import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/order`;
const cookie = new Cookies();

export const userWallet = async (amount) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.post(
      `${endPoint}/userWallet`,
      {
        amount,
      },
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};
